import React, { useEffect, useState } from "react";
import { NavigationalButtons } from "./CreateAudioWizard";
import { Form, Formik, useFormikContext } from "formik";
import useAxios from "axios-hooks";
import TextCKEditor from "../../../../Forms/TextCKEditor";
import TextField from "../../../../Forms/TextField";
import DropDown from "../../../../Forms/DropDown";
import { DefaultButton, PrimaryButton, Spinner, Label, Text } from "@fluentui/react";

const TranslationsStep = ({ audioId, nextOnClick, prevOnClick, transcript, audio }) => {

    const [{ loading: loading, data: translations }, getTranslations] = useAxios(
        {
            url: `resources/audio/${audioId}/translations`,
            method: "get",
        }
    );

    const [{}, deleteTranslation] = useAxios(
        {
            url: `resources/audio/${audioId}/translations`,
            method: "delete",
        },
        { manual: true }
    );

    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `resources/audio/${audioId}/translations`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: languages, loading: loadingLanguages}] = useAxios(
        {
          url:`/resources/audio/languages`, method: "get"
        });


    const [showTranslationForm, setShowTranslationForm] = useState(false);
    const [translation, setTranslation] = useState(null);

    if (loading || submitting  || !audio) {
        return (
            <Spinner className="absolute-center" label="Loading..." />
        );
    }

    return (
        <div>
            <Formik
                initialValues={{title: "", description: "", languageId: "", conTranslatedId: "", transcript: ""}}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    getTranslations();
                }}
            >
                <TranslationForm translations={translations} nextOnClick={nextOnClick} prevOnClick={prevOnClick} audio={audio} 
                    languages={languages} deleteTranslation={deleteTranslation} getTranslations={getTranslations} ></TranslationForm>
            </Formik>
        </div>
    )

};


const TranslationForm = ({translations, nextOnClick, prevOnClick, languages, deleteTranslation, getTranslations, audio={audio}}) => {

    const { setFieldValue, getFieldProps } = useFormikContext();

    const languageOptions = languages ? languages.map(language => 
        {   
            var obj = { key: language.languageId.toString(), text: language.name }
            var translationFound = translations && translations.find(x => x.languageId == language.languageId);
            if (translationFound) {
                obj.text += " --------- Translation Exists ------------";
            }
            return obj;
        }
    ) : [];
    
    const clearCurrentTranslation = () => {
        setFieldValue("conTranslatedId", "");
        setFieldValue("title", "");
        setFieldValue("description", "");
        setFieldValue("transcript", "");
    }

    return (
        <div>

                <Form>
                    {getFieldProps("conTranslatedId").value && 
                        <DefaultButton 
                        styles={{
                            root: {
                            backgroundColor: '#d9534f',
                            color: '#fff',
                            },
                            rootHovered: {
                            backgroundColor: '#ea645f',
                            color: '#fff',
                            }        
                        }}
                        onClick={() => {
                            deleteTranslation(getFieldProps("conTranslatedId").value).then(res => {
                                getTranslations();
                            });
                            clearCurrentTranslation();
                        }} >
                            Delete
                        </DefaultButton>
                    }
                    <DropDown label="Language" name={`languageId`} options={languageOptions}
                        onChange={(e,v) => {
                            setFieldValue("languageId", v.key);

                            var translationFound = translations.find(x => x.languageId == v.key);

                            if (translationFound) {
                                setFieldValue("conTranslatedId", translationFound.conTranslatedId);
                                setFieldValue("title", translationFound.title);
                                setFieldValue("description", translationFound.description);
                                setFieldValue("transcript", translationFound.transcript);
                            }
                            else if (getFieldProps("conTranslatedId").value) {
                                clearCurrentTranslation();
                            }
                            
                        }}
                    />
                    <TextField 
                        label="Transcript Title"
                        name="title"
                    />
                    <div>
                        <Label>Translated Audio Description <Text variant="small" styles={{ root: { color: "#605e5c", fontWeight: 400, display: "inline" } }}>(supports HTML formatting)</Text></Label>
                        <TextCKEditor
                            value={getFieldProps("description").value || ""}
                            onChange={(val) => setFieldValue("description", val)}
                        />
                    </div>
                    <div>
                        <Label>Translated Audio Transcript <Text variant="small" styles={{ root: { color: "#605e5c", fontWeight: 400, display: "inline" } }}>(supports HTML formatting)</Text></Label>
                        <TextCKEditor
                            value={getFieldProps("transcript").value || ""}
                            onChange={(val) => setFieldValue("transcript", val)}
                        />
                    </div>
                    <NavigationalButtons
                        onNextProps={{ type: "submit", text: "Save" }}
                        onPrevHandler={prevOnClick}
                    />

                </Form>
        </div>
    );
}

export default TranslationsStep;
